module.exports = __webpack_public_path__ + "img/project2.23cfae0d.jpg";